/**
 * Show/hide GWP breakdown sections based on current variant and promo code
 * @param {string} variantId
 * @param {string} promoCode
 */
function showGwpBreakdownSections(variantId, promoCode) {
  console.log('[GWP] showGwpBreakdownSections called with:', { variantId, promoCode });
  Array.from(document.querySelectorAll('.gwp-breakdown-section')).forEach(el => {
    if (el.classList.contains(`${variantId}-${promoCode}`)) {
      el.style.display = 'block';
      el.parentElement.style.display = 'block';
    } else {
      el.style.display = 'none';
      el.parentElement.style.display = 'none';
    }
  });
}

// Track the priority source for GWP
window.gwpPrioritySource = null;

/**
 * Change the current GWP selection and update breakdown UI
 * @param {string} variantId - Shopify variant ID for the gift product
 * @param {string} promoCode - Discount code for the gift
 * @param {string|null} source - Source of the call, if any (high priority sources take precedence)
 */
function changeGWP(variantId, promoCode, source = null) {
  const isPriority = source === 'abtasty';
  
  // Check if call is from a priority source - if so, set the flag
  if (isPriority) {
    window.gwpPrioritySource = source;
    console.log(`[GWP] Called by priority source (${source}), taking priority`);
  } else if (window.gwpPrioritySource) {
    // If a priority source has already called this function, ignore non-priority calls
    console.log(`[GWP] Ignoring non-priority call as ${window.gwpPrioritySource} has priority`);
    return;
  }

  // If only one is empty/missing (or they are otherwise invalid), it's an error for normal GWP operation.
  if (!variantId || !promoCode) {
    console.trace('[GWP] changeGWP called with incomplete params (one param missing or invalid).');
    return;
  }

  if (variantId && promoCode) {
    console.log('GWP theme and journey is disabled but temp enabling as this was called with valid params');
    window.journey_gwp_enabled = true;
    window.journey_gwp_variant_id = variantId;
    window.journey_gwp_promo_code = promoCode;
  }
  const originalPromoCode = `${promoCode}`;
  if (promoCode) {
    promoCode = `%2C${promoCode}`;
  }
  console.log('[GWP] changeGWP called with:', { variantId, promoCode, source });

  // Set global variables for cart logic as per GWP_Implementation.md
  window.gift_id = variantId;
  window.gift_code = promoCode;
  window.currentGWP = { variantId, promoCode };

  // Update breakdown sections
  showGwpBreakdownSections(variantId, originalPromoCode);

  updateGwpUiElements();
}

/**
 * Format price according to Shopify conventions
 * @param {number} price - Price in cents
 * @returns {string} - Formatted price string
 */
function formatPrice(price) {
  return `£${(price / 100)}`;
}

/**
 * Update GWP UI elements with dynamic data
 */
function updateGwpUiElements() {
  const headingElSelector = '.journey_widget .free-gift-heading';
  const initialHeadingEl = document.querySelector(headingElSelector);

  console.log('[GWP] updateGwpUiElements called. CurrentGWP:', window.currentGWP, 'Initial headingEl:', initialHeadingEl);
  
  if (initialHeadingEl && window.currentGWP) {
    const giftVariant = window.giftVariants.find(g => g.id == window.journey_gwp_variant_id);
    if (giftVariant) {
      const formattedPrice = `£${(giftVariant.price / 100)}`;
      const expectedText = `plus FREE gift worth ${formattedPrice}`;
      const freeGiftWorth = document.querySelector('#free-gift-worth');
      if (freeGiftWorth) {
        freeGiftWorth.style.display = 'block';
        freeGiftWorth.innerText = `Plus FREE gift worth ${formattedPrice}`;
      }
      console.log(`[GWP] Gift variant found. Expected text for heading: "${expectedText}"`);

      const currentHeadingEl = document.querySelector(headingElSelector); 
      if (currentHeadingEl) {
        currentHeadingEl.innerText = expectedText;
        currentHeadingEl.removeAttribute('hidden');
        console.log(`[GWP] Set heading ${headingElSelector} to: "${expectedText}", Not Hidden.`);
      } else {
        console.warn('[GWP] Heading element not found during update.');
      }

    } else {
      console.warn(`[GWP] Gift variant not found for ID: ${window.journey_gwp_variant_id}. Hiding free gift heading.`);
      if (initialHeadingEl) {
        initialHeadingEl.hidden = true;
      }
    }
  } else if (initialHeadingEl && !window.currentGWP) {
      console.log('[GWP] No currentGWP data, ensuring heading element is hidden.');
      initialHeadingEl.hidden = true;
  } else if (!initialHeadingEl && window.currentGWP) {
      console.warn('[GWP] Heading element .journey_widget .free-gift-heading not found, cannot update GWP text.');
  }
  
  // Show other GWP elements
  document.querySelectorAll('.free-gift-test').forEach(el => {
    el.removeAttribute('hidden');
  });
  
  // Show free gift section if it exists
  const freeGiftSection = document.querySelector('#free-gift-section');
  if (freeGiftSection) {
    freeGiftSection.style.display = 'block';
  }

  // Set up click handler for free-gift-section-link
  const freeGiftSectionLink = document.getElementById('free-gift-section-link');
  if (freeGiftSectionLink) {
    freeGiftSectionLink.addEventListener('click', function(e) {
      e.preventDefault();
      // Target the section by ID since that's what's in the HTML
      const targetSection = Array.from(document.querySelectorAll('#free-gift-section')).find(el => el.parentElement.style.display === 'block');
      if (targetSection) {
        targetSection.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }
  
  // Add the appropriate class to the widget
  document.querySelectorAll('.journey-main-widget').forEach(widget => {
    widget.classList.add('ab-free-gift-on');
    widget.classList.remove('ab-free-gift-off');
  });
}

// Make functions available globally for theme.liquid inline usage
window.showGwpBreakdownSections = showGwpBreakdownSections;
window.changeGWP = changeGWP;

// Single, global initialization
function gwpSingleInit() {
  console.log('gwpSingleInit called');

  // Reset the priority source on initialization
  window.gwpPrioritySource = null;

  // Priority: journey GWP (if enabled and has variant), else theme GWP (if enabled and has variant), else clear
  if (window.journey_gwp_enabled && window.journey_gwp_variant_id) {
    console.log('[GWP] Initializing from journey metafields');
    const promoCode = window.journey_gwp_promo_code || ''; // Default to empty string
    const price = window.journey_gwp_price;
    changeGWP(window.journey_gwp_variant_id, promoCode, null); // Not from priority source
  } else if (window.theme_gwp_enabled && window.theme_gwp_variant_id) {
    console.log('[GWP] Initializing from theme settings');
    const promoCode = window.theme_gwp_promo_code || ''; // Default to empty string
    changeGWP(window.theme_gwp_variant_id, promoCode, null); // Not from priority source
  } else {
    console.log('[GWP] No journey, product, or theme GWP found, clearing');
    changeGWP('', '', null); // Not from priority source
  }
}

document.addEventListener('DOMContentLoaded', gwpSingleInit);